<template>
  <div class="lease-service">
    <el-table :data="list" class="table-shin-expand">
      <el-table-column type="expand">
        <template scope="props">
          <el-checkbox class="check-all" :disabled="checkLotLines(props.row)" v-model="multiCheck[props.row.LineId].checkAll" @change="handleCheckAllChange($event, props.row)">全选</el-checkbox>
          <el-checkbox-group v-model="multiCheck[props.row.LineId].checkedRow" @change="handleCheckItemChange($event, props.row)">
            <div class="inner-list" v-for="row in props.row.LotLines" :key="row.LotId">
              <el-checkbox class="checkbox" :disabled="!!row.AfterSalesRequestType && row.AfterSalesRequestState !== 'cancelled'" :label="row.LotId" :key="row.LotId">{{''}}</el-checkbox>
              <div class="list-item">
                <label>批次号</label>
                <p class="no-margin">{{row.LotCode}}</p>
              </div>
              <div class="list-item" style="text-align: center;">
                <el-tag type="primary" style="margin-top: 8px">{{row.ConditionName}}</el-tag>
              </div>
              <div class="list-item">
                <label>租赁周期：</label>
                <p class="no-margin">{{row.RentalPeriod}}个月</p>
              </div>
              <div class="list-item">
                <label>折扣：</label>
                <p class="no-margin">{{row.DiscountRate * 100}}%</p>
              </div>
              <div class="list-item">
                <label>租赁单价：</label>
                <p class="no-margin">￥{{row.RentalUnitPrice}}</p>
              </div>
              <div class="list-item">
                <label>保修：</label>
                <p class="no-margin">￥{{row.WarrantyAmount}}/{{row.WarrantyMonths * 30}}天</p>
              </div>
              <div class="list-item">
                <label>剩余保修时间：</label>
                <p class="no-margin" v-show="row.WarrantyLeftDays > 0">{{Math.round(row.WarrantyLeftDays)}}天</p>
                <p class="no-margin" style="color: #FF4949" v-show="row.WarrantyMonths !== 0 && row.WarrantyLeftDays <= 0">过保</p>
                <p class="no-margin" v-show="row.WarrantyMonths === 0">无</p>
              </div>
              <div class="list-item">
                <label>租金：
                  <el-tooltip popper-class="blue-tooltip" effect="dark" content="租赁单价*数量+保修费用" placement="top">
                    <i class="el-icon-information"></i>
                  </el-tooltip>
                </label>
                <p class="no-margin">￥{{row.RentalAmount}}</p>
              </div>
              <div class="list-item">
                <label>起租时间：</label>
                <p class="no-margin">{{row.StartDate | date('YYYY/MM/DD')}}</p>
              </div>
              <div class="list-item">
                <label>已租时长：</label>
                <p class="no-margin">{{Math.round(row.RentDays)}}天</p>
              </div>
              <div class="list-item" v-show="row.AfterSalesRequestType || row.AfterSalesType">
                <p v-show="(row.AfterSalesRequestType || row.AfterSalesType) === 'repair' && row.AfterSalesRequestState !== 'cancelled'" type="text">维修售后中</p>
                <p v-show="(row.AfterSalesRequestType || row.AfterSalesType) === 'renewal' && row.AfterSalesRequestState !== 'cancelled'" type="text">续租售后中</p>
                <p v-show="(row.AfterSalesRequestType || row.AfterSalesType) === 'return' && row.AfterSalesRequestState !== 'cancelled'" type="text">退还售后中</p>
              </div>
            </div>
          </el-checkbox-group>
        </template>
      </el-table-column>
      <el-table-column label="物料名称" width="200px">
        <template scope="props">
          <p class="no-margin">{{props.row.ProductName}}</p>
          <p class="no-margin">物料编码：{{props.row.ProductCode}}</p>
        </template>
      </el-table-column>
      <el-table-column label="客户物料名称">
        <template scope="props">
          <p class="no-margin">{{props.row.CustomerProductName}}</p>
          <p class="no-margin" v-show="props.row.CustomerProductCode">物料编码：{{props.row.CustomerProductCode}}</p>
        </template>
      </el-table-column>
      <el-table-column label="品牌" prop="BrandName"></el-table-column>
      <el-table-column label="机型" prop="ModelName"></el-table-column>
      <el-table-column label="模块" prop="ModuleName"></el-table-column>
      <el-table-column label="租赁数量" prop="RentalQuantity"></el-table-column>
      <el-table-column label="保修期">
        <template scope="props">{{props.row.WarrantyMonths}}个月/{{props.row.WarrantyAmount}}元</template>
      </el-table-column>
      <el-table-column label="操作" class="lease001">
        <template scope="props">
          <el-button type="primary" size="mini" @click="handleRepairFormDialogOpen(props.row)">维修</el-button>
          <el-button type="primary" size="mini" @click="handleRenewFormDialogOpen(props.row)">续租</el-button>
          <el-button type="primary" size="mini" @click="handleReturnFormDialogOpen(props.row)">退还</el-button>
        </template>
      </el-table-column>
    </el-table>

    <repair-form-dialog :show.sync="repairFormDialog.show" :list="repairFormDialog.list" @confirm="handleConfirm"></repair-form-dialog>
    <renew-form-dialog :show.sync="renewalFormDialog.show" :list="renewalFormDialog.list" @confirm="handleConfirm"></renew-form-dialog>
    <return-form-dialog :show.sync="returnFormDialog.show" :list="returnFormDialog.list" @confirm="handleConfirm"></return-form-dialog>

  </div>
</template>

<script>
import RepairFormDialog from './RepairFormDialog'
import RenewFormDialog from './RenewFormDialog'
import ReturnFormDialog from './ReturnFormDialog'
import o from '@/odata'
export default {
  props: {
    list: {
      type: Array,
      required: true,
    },
    orderId: {
      type: null,
      required: true,
    },
  },
  data() {
    return {
      multiCheck: {},
      repairFormDialog: {
        show: false,
        list: [],
      },
      repairDetailDialog: {
        show: false,
        list: [],
      },
      returnFormDialog: {
        show: false,
        list: [],
      },
      returnDetailDialog: {
        show: false,
        list: [],
      },
      renewalFormDialog: {
        show: false,
        list: [],
      },
      renewDetailDialog: {
        show: false,
        list: [],
      },
    }
  },
  methods: {
    handleCheckAllChange(event, { LineId, LotLines }) {
      const filterLines = LotLines.filter(item => !item.AfterSalesRequestType || item.AfterSalesRequestState === 'cancelled')
      this.multiCheck[LineId].checkedRow = event.target.checked ? filterLines.map(item => item.LotId) : []
    },
    handleCheckItemChange(value, { LineId, LotLines }) {
      console.log('check', value)
      const checkedCount = value.length
      const filterLines = LotLines.filter(item => !item.AfterSalesRequestType || item.AfterSalesRequestState === 'cancelled')
      this.multiCheck[LineId].checkAll = checkedCount === filterLines.length
    },
    checkLotLines({ LotLines }) {
      const filterLines = LotLines.filter(item => !item.AfterSalesRequestType || item.AfterSalesRequestState === 'cancelled')
      return filterLines.length === 0
    },
    getSelected(row) {
      const selectedIds = this.multiCheck[row.LineId].checkedRow
      return selectedIds.map(Id => {
        return row.LotLines.find(line => line.LotId === Id)
      })
    },
    handleRepairFormDialogOpen(row) {
      const selected = this.getSelected(row)
      if (selected.length === 0) {
        return this.$alert('请选择批次！')
      }
      this.repairFormDialog.list = selected
      this.repairFormDialog.show = true
    },
    handleRenewFormDialogOpen(row) {
      const selected = this.getSelected(row)
      if (selected.length === 0) {
        return this.$alert('请选择批次！')
      }
      this.renewalFormDialog.list = selected
      this.renewalFormDialog.show = true
    },
    handleReturnFormDialogOpen(row) {
      const selected = this.getSelected(row)
      if (selected.length === 0) {
        return this.$alert('请选择批次！')
      }
      this.returnFormDialog.list = selected
      this.returnFormDialog.show = true
    },
    handleConfirm(type, data) {
      const form = Object.assign({}, data, {
        RentalOrderId: this.orderId,
        PartnerId: 2,
        Type: type.toLocaleLowerCase(),
      })
      o('AfterSalesRequest').post(form).save().then(() => {
        this[type.toLocaleLowerCase() + 'FormDialog'].show = false
        this.$message('操作成功')
        window.location.reload()
      }).catch(err => {
        this.$alert('服务器异常')
        console.error(err)
      })
    },
  },
  created() {
    this.list.forEach(item => {
      this.$set(this.multiCheck, item.LineId, {
        checkAll: false,
        checkedRow: [],
      })
    })
  },
  components: {
    RepairFormDialog,
    RenewFormDialog,
    ReturnFormDialog,
  },
}
</script>

<style lang="less" scoped>
.el-icon-information:hover {
  color: #20a0ff;
}

.sent-lot-title {
  color: #e88603;
  font-size: 13px;
  margin: 26px 0 0 58px;
  &:before {
    content: ' ';
    display: inline-block;
  }
}

.check-all {
  margin-top: 20px;
  margin-left: 58px;
}

.inner-list {
  margin: 0 30px;
  padding: 16px 28px;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  border-bottom: 1px solid #e6eaee;
  .checkbox {
    margin-right: 10px;
    padding-top: 8px;
  }
  &:last-child {
    border-bottom: none;
  }
  .list-item {
    margin-right: 20px;
    min-width: 50px;
    font-weight: bold;
    &:last-child {
      margin-right: 0;
    }
    label {
      font-size: 12px;
      color: #86939e;
      line-height: 1.5;
    }
    p {
      color: #364152;
    }
  }
}
</style>

<style lang="less">
.el-tooltip__popper.is-dark.blue-tooltip {
  background: #20a0ff;
  .popper__arrow,
  .popper__arrow::after {
    border-top-color: #20a0ff;
  }
}
.el-table__row{
  .el-button+.el-button{margin-left: 0;}
}
</style>



// WEBPACK FOOTER //
// LeaseDetailTableService.vue?0c663cf6